// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__1gZsC","empty":"ModalGraph_empty__3Ofjd"};